import { render, staticRenderFns } from "./app-install-list.vue?vue&type=template&id=2ddbeaa0&scoped=true&"
import script from "./app-install-list.vue?vue&type=script&lang=js&"
export * from "./app-install-list.vue?vue&type=script&lang=js&"
import style0 from "./app-install-list.vue?vue&type=style&index=0&id=2ddbeaa0&prod&scoped=true&lang=less&"
import style1 from "./app-install-list.vue?vue&type=style&index=1&id=2ddbeaa0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbeaa0",
  null
  
)

export default component.exports